import { Content } from "@/ui";
import { createTitle } from "@/functions/createTitle";
import { jobs_helper } from "@/helpers/jobs_helper";
import * as additionalComponents from "./__components";
import { getRoute } from "@/getters/getRoute";

export default function ApplyThankYouPage({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const job = jobs_helper.find(url_slug);
  const sectorsIds = jobs_helper.getCategoryValueIds("3186657c-e89c-4a6f-9157-35eb7fe0b379", job);
  const JobTypeIds = jobs_helper.getCategoryValueIds("275d8990-bd9e-4f79-a0e2-d81bb734c855", job);
  const related = jobs_helper.fetch({
    limit: 10,
    exclude: [job.id],
    filter: (i) => 
      sectorsIds.some((s) => JSON.stringify(i.categories).includes(s)) &&
      JobTypeIds.some((s) => JSON.stringify(i.categories).includes(s))
  });

  return {
    props: {
      meta: {
        title: createTitle("Application Complete"),
      },
      job,
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              { label: "Find a Job", href: getRoute("jobs") },
              { label: job.title, href: getRoute("job", { url_slug }) },
              { label: "Thank you for your application" },
            ],
          },
        },
        { component: "JobApplicationCompleteHeader", props: { ...job } },
        { component: "JobApplicationCompleteContent", props: { ...job, related } },
      ],
    },
  };
}

export async function getStaticPaths() {
  return { paths: jobs_helper.toPaths(), fallback: false };
}
